import { showFullScreenLoader, SnackBarHelper } from '@lyearn-team/frontend-components';
import { ReportingLibrary, ReportRequestTypeEnum } from '@lyearn-team/reporting-library';

import fetchContentVersions from 'helper/fetchContentVersions';

import { fetchPathOfferRemotely, fetchPathOfferLocally } from './fetchPathOffer';
import { user } from '../currentUser';
import switchToLatestVersion from '../switchToLatestVersion';
import { ContentTypesLowercaseEnum } from '../../appConsts';
import isContentAssigned from '../isContentAssigned';

export async function fetchLearnerPathLocally(pathId, userId) {
  return fetchPathOfferLocally(pathId, userId);
}

export async function fetchLearnerPathRemotely(pathId, userId) {
  const companyId = user.companyId();

  let pathOfferData = await fetchPathOfferRemotely(pathId, userId);

  const pathOfferEnrolment = pathOfferData.enrolments.find(e => e.contentId === pathId);
  const isPathAssigned = isContentAssigned(pathOfferEnrolment);

  if (isPathAssigned) {
    const pathVersions = await fetchContentVersions(new ReportingLibrary(), pathId, {
      type: ReportRequestTypeEnum.PAGINATED,
      from: 0,
      size: 1
    });
    const currentVersionId = pathOfferEnrolment.versionId;
    if (pathVersions.reports.length < 1) {
      if (window.pathVersions !== undefined) {
        if (window.pathVersions.indexOf(pathId) === -1) {
          window.pathVersions.push(pathId);
          const error = new Error('Missing PathVersions');
          window.bugsnagClient &&
            window.bugsnagClient.notify(error, {
              metaData: {
                pathId
              }
            });
        }
      } else {
        window.pathVersions = [pathId];
      }
    }
    const latestVersionId = pathVersions.reports.length
      ? pathVersions.reports[0].contentVersionLog.versionId
      : '';
    if (latestVersionId && currentVersionId !== latestVersionId) {
      const { hideLoader } = showFullScreenLoader();
      await switchToLatestVersion(
        userId,
        companyId,
        pathId,
        ContentTypesLowercaseEnum.curriculumOffer,
        currentVersionId,
        latestVersionId
      );
      pathOfferData = await fetchPathOfferRemotely(pathId, userId);
      hideLoader();
      SnackBarHelper.showSnackbar({
        label: 'This path has been updated since you last visited',
        duration: 7
      });
    }
  }

  return pathOfferData;
}

export async function fetchLearnerPathLocallyOrRemotely(pathId, userId) {
  const localData = await fetchPathOfferLocally(pathId, userId);

  if (localData) return localData;

  return fetchLearnerPathRemotely(pathId, userId);
}
